import { FC, ReactNode } from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import { Plus, Minus } from "lucide-react";
import cx from "classnames";

export interface CollapsibleItemProps {
  id?: number;
  label: string;
  description?: string | ReactNode;
  className?: string;
  itemClassName?: string;
  isOpen?: boolean;
  isLast?: boolean;
  onToggle?: () => void;
}

const CollapsibleItem: FC<CollapsibleItemProps> = ({
  label,
  description,
  className,
  itemClassName = "text-lg font-medium",
  isOpen = false,
  isLast = false,
  onToggle,
}) => {
  const borderClass = isLast ? "" : "border-b border-dashed border-[#DDDDDD]";

  if (!description) {
    return (
      <div className={cx(className, borderClass, "w-full pt-4 pb-[25px]")}>
        <div className="flex w-full items-center justify-between gap-[16px]">
          <span
            className={cx(itemClassName, "text-start font-bold text-[#181818]")}
          >
            {label}
          </span>
        </div>
      </div>
    );
  }

  return (
    <Collapsible.Root
      className={cx(className, borderClass, "w-full")}
      open={isOpen}
      onOpenChange={onToggle}
    >
      <div className="w-full">
        <Collapsible.Trigger asChild>
          <button className="text-medium flex w-full cursor-pointer items-center justify-between gap-[16px] border-none bg-transparent py-[25px]">
            <span
              className={cx(
                itemClassName,
                "text-start font-medium text-[#181818]",
              )}
            >
              {label}
            </span>
            <div className="flex shrink-0 items-center justify-center text-[#181818]">
              {isOpen ? (
                <Minus size={24} strokeWidth={1.5} />
              ) : (
                <Plus size={24} strokeWidth={1.5} />
              )}
            </div>
          </button>
        </Collapsible.Trigger>
      </div>

      <Collapsible.Content>
        <div className="flex w-full flex-col gap-[10px] pb-[25px]">
          <div className="w-full text-left font-['Figtree'] text-[16px] leading-[130%] font-normal text-[#7A7A7A]">
            {description}
          </div>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default CollapsibleItem;
